module.exports = __webpack_public_path__ + "img/logo.1d424f6e.svg";